<template>
  <el-dialog
      title="居民数据"
      :visible.sync="residentDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="1200px"
      center>
    <el-form :model="residentForm" ref="residentForm" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="社区：">
            <el-input :value="project" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="小区：">
            <el-input :value="community" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="楼门户：">
            <el-input :value="residentForm.room" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="姓名：">
            <el-input :value="residentForm.name" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别：">
            <el-input :value="residentForm.sex" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="民族：">
            <el-input :value="residentForm.nation" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证：">
            <el-input :value="residentForm.idCard" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号：">
            <el-input :value="residentForm.phone" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态：">
            <el-input :value="residentForm.live" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="与户主关系：" prop="relation">
            <el-input :value="residentForm.relation" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="户口性质：" prop="nature">
            <el-input :value="residentForm.nature" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="户籍地：" prop="register">
            <el-input :value="residentForm.register" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="健康状态：" >
            <el-select v-model="residentForm.health" class="w-all"  disabled>
              <el-option
                v-for="item in health"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="标签：" >
            <el-select v-model="residentForm.health" class="w-all"  disabled>
              <el-option
                v-for="item in health"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注：" prop="desc">
            <el-input type="textarea" :value="residentForm.desc" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" type="primary" @click="resetForm('residentForm')">关闭</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {sex, nation, live, nature, relation, filesCN, optionList, health} from "@/utils/utils";

export default {
  name: "residentDetail",
  props: {
    residentDetail: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {
    return {
      health: optionList(false, health),
      project: '',
      community: '',
      residentForm: {
        building: '',
        unit: '',
        room: '',
        name: '',
        sex: '',
        nation: '',
        idCard: '',
        phone: '',
        live: '',
        relation: '',
        nature: '',
        register: '',
        health:'',
        tags:'',
        desc: ''
      }
    }
  },
  created() {
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    resetForm(formName) {
      this.$emit('cancelDialog', false)
    },
  },
  watch: {
    setItem() {
      if(this.setItem.xiangmu_name){
        this.project = this.setItem.xiangmu_name
        this.community = this.setItem.xiaoqu_name
        this.residentForm = {
          room: this.setItem.building_name +'-'+ this.setItem.element_name +'-'+ this.setItem.room_name,
          name: this.setItem.name,
          sex: filesCN(this.setItem.sex, sex),
          nation: filesCN(this.setItem.minzu, nation),
          idCard: this.setItem.id_card,
          phone: this.setItem.phone,
          live: filesCN(this.setItem.status, live),
          relation: filesCN(this.setItem.yuhuzhuguanxi, relation),
          nature: filesCN(this.setItem.hukouxingzhi, nature),
          register: this.setItem.hujidi,
          desc: this.setItem.beizhu,
        };
      }
    },

  }
}
</script>

<style scoped lang="scss">

</style>
